import { pushToDataLayer } from '../dataLayer'
import type { IMessageCatch, TKindActionMenu } from './types'

const catchEventActionBulk = (props: IMessageCatch): void => {
  const { message } = props

  pushToDataLayer({
    eventAction: 'erro',
    eventCategory: 'produto:catalogo:acoes-em-massa',
    eventLabel: `${message}`,
  })
}

const catchEventFilterSearch = (props: IMessageCatch): void => {
  const { message } = props

  pushToDataLayer({
    eventAction: 'erro',
    eventCategory: 'produto:catalogo:busca',
    eventLabel: `${message}`,
  })
}

const catchEventIconInventoryFulfillment = (props: IMessageCatch): void => {
  const { message } = props

  pushToDataLayer({
    eventAction: 'erro',
    eventCategory: 'produto:catalogo:estoque-fulfillment',
    eventLabel: `${message}`,
  })
}

const catchEventFastUpdate = (props: IMessageCatch): void => {
  const { message } = props

  pushToDataLayer({
    eventAction: 'erro',
    eventCategory: 'produto:catalogo:edicao',
    eventLabel: `${message}`,
  })
}

const catchEventImportSheet = (props: IMessageCatch): void => {
  const { message } = props

  pushToDataLayer({
    eventAction: 'erro',
    eventCategory: 'produto:importar-planilha',
    eventLabel: `${message}`,
  })
}

const catchEventApi = ({ message }: IMessageCatch): void => {
  pushToDataLayer({
    eventAction: 'erro',
    eventCategory: 'produto:api',
    eventLabel: `${message}`,
  })
}

const catchEventApp = ({ message }: IMessageCatch): void => {
  pushToDataLayer({
    eventAction: 'erro',
    eventCategory: 'produto:app',
    eventLabel: `${message}`,
  })
}

const catchEventCreateProduct = (props: IMessageCatch): void => {
  const { message } = props

  pushToDataLayer({
    eventAction: 'erro',
    eventCategory: 'produto:novo',
    eventLabel: `${message}`,
  })
}

const catchEventSearchProduct = ({ message }: IMessageCatch): void => {
  pushToDataLayer({
    eventAction: 'erro',
    eventCategory: 'produto:cadastrar:busca',
    eventLabel: `${message}`,
  })
}

const catchEventEditProduct = ({ message }: IMessageCatch): void => {
  pushToDataLayer({
    eventAction: 'erro',
    eventCategory: 'produto:editar',
    eventLabel: `${message}`,
  })
}

const catchEventActionMenuError = (kind: TKindActionMenu, error: string): void => {
  const getKind = {
    NEW_SIMILAR: 'duplicar',
    LINK_EDIT: 'editar',
    LINK_MARKETPLACE: 'abrir-no-site',
    PUBLISH: 'publicar',
    UNPUBLISH: 'despublicar',
    VIEW_HISTORY_TIMELINE: 'historico',
    INACTIVE: 'inativar',
    PERFORMANCE: 'ver-desempenho',
  }

  pushToDataLayer({
    event: 'select_content_error',
    content_type: 'portal-seller:catalogo-produtos:produto',
    content_id: getKind[kind],
    error,
  })
}

const catchEventOpenCostSimulatorError = (error: string): void => {
  pushToDataLayer({
    event: 'select_content_error',
    content_type: 'portal-seller:catalogo-produtos:produto',
    content_id: 'calculadora-de-custos',
    error,
  })
}

const catchEventIconQueueDetailsError = (error: string): void => {
  pushToDataLayer({
    event: 'select_content_error',
    content_type: 'portal-seller:catalogo-produtos:produto',
    content_id: 'ver-detalhes',
    error,
  })
}

const catchEventSaveUpdatedProductPriceError = (error: string): void => {
  pushToDataLayer({
    event: 'select_content_error',
    content_type: 'portal-seller:catalogo-produtos:produto',
    content_id: 'alterar-preco:salvar',
    error,
  })
}

const catchEventOpenPromotionsDialogError = (error: string): void => {
  pushToDataLayer({
    event: 'select_content_error',
    content_type: 'portal-seller:catalogo-produtos:produto',
    content_id: 'preco:promocao-ativa',
    error,
  })
}

export {
  catchEventActionBulk,
  catchEventFilterSearch,
  catchEventIconInventoryFulfillment,
  catchEventFastUpdate,
  catchEventImportSheet,
  catchEventApi,
  catchEventApp,
  catchEventCreateProduct,
  catchEventSearchProduct,
  catchEventEditProduct,
  catchEventActionMenuError,
  catchEventOpenCostSimulatorError,
  catchEventIconQueueDetailsError,
  catchEventSaveUpdatedProductPriceError,
  catchEventOpenPromotionsDialogError,
}
